import { useListPagination } from 'src/hooks/useListPagination'

export const useUserGroupsFilters = () => {
  const { pagination, changePage, changePageSize, resetToFirstPage } =
    useListPagination({ storageKeyPrefix: 'userGroups' })

  return {
    filters: pagination,
    changePage,
    changePageSize,
    resetToFirstPage,
  }
}
